<template>
  <div>
    <div class="flex" style="justify-content: space-between">
      <!-- 左侧的搜索框 -->
      <div>
        <a-input-search
          v-model="searchValue"
          :placeholder="config.searchPlaceholder"
          @search="loadData()"
        ></a-input-search>
      </div>
      <!-- 右侧的自定义按钮 -->
      <div>
        <slot name="tableHeaderRender" :selectedRowKeys="selectedRowKeys"></slot>
      </div>
    </div>
    <div class="mt-24">
      <a-table
        :columns="columns"
        :data-source="data"
        :rowKey="config.rowKey"
        :rowSelection="config.selectedAble ? { selectedRowKeys: selectedRowKeys, onChange: onSelectChange } : null"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange"
        :expandRowByClick="config.expandedAble"
        :expandedRowKeys="expandedRowKeys"
        @expand="handleExpand"
        bordered
      >
        <template v-if="config.expandedAble" v-slot:expandedRowRender="key">
          <slot name="expandedRowRender" v-bind="key"></slot>
        </template>
        <!-- 表格内容的slot -->
        <template v-for="custom in columnsCustoms" v-slot:[custom.customRender]="text, record, index">
          <slot :name="custom.customRender" v-bind="{ text, record, index }"></slot>
        </template>
        <!-- 表格filter的slot -->
        <template
          v-for="custom in searchsCustoms"
          v-slot:[custom.filterDropdown]="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        >
          <slot
            :name="custom.filterDropdown"
            v-bind="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          ></slot>
        </template>
        <!-- 表格filter的slot -->
        <template
          v-for="custom in filtersCustoms"
          v-slot:[custom.filterDropdown]="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        >
          <slot
            :name="custom.filterDropdown"
            v-bind="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          ></slot>
        </template>
        <!-- 表格title的slot -->
        <template v-for="custom in titlesCustoms" v-slot:[custom.title]>
          <slot :name="custom.title"></slot>
        </template>
        <template slot="footer">
          <div class="flex" style="justify-content: space-between">
            <div>
              <span>共找到了{{ config.pagination.total }}条数据</span>
              <span> , </span>
              <a-button type="link" style="padding: 0" @click="handleReset">重置查询条件</a-button>
            </div>
            <div>
              <a-pagination
                show-quick-jumper
                show-size-changer
                v-model="config.pagination.pageNo"
                :pageSize.sync="config.pagination.pageSize"
                :total="config.pagination.total || 1"
                @change="handleChangePage"
                @showSizeChange="handleChangePageSize"
              />
            </div>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'CustomTable',
  props: {
    oriConfig: {
      type: Object,
      default: () => {
        return {
          searchPlaceholder: '',
          loadData: () => {},
          pagination: {
            pageNo: 1,
            pageSize: 10,
          },
        }
      },
    },
    columns: {
      type: Array,
      default: () => [],
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
    expandedRowKeys: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    oriConfig: {
      immediate: true,
      handler: function (val) {
        this.config = cloneDeep(val)
        this.columnsCustoms = this.columns
          .filter((record) => record?.scopedSlots?.customRender)
          .map((item) => item.scopedSlots)
        this.filtersCustoms = this.columns
          .filter(
            (record) => record?.scopedSlots?.filterDropdown && record.scopedSlots.filterDropdown != 'searchDropdown'
          )
          .map((item) => item.scopedSlots)
        this.searchsCustoms = this.columns
          .filter((record) => record?.scopedSlots?.filterDropdown?.filterDropdown == 'searchDropdown')
          .map((item) => item.scopedSlots)
        this.titlesCustoms = this.columns.filter((record) => record?.slots?.title).map((item) => item.slots)
        this.searchValue = this.config.searchValue
        this.queryParam.filter = { ...this.config.otherParam, ...this.config.loadParam }
        if (this.config.orderParam) {
          var param = this.config.orderParam.split('.')
          let sortBy = param[0]
          let orderBy = param[1]
          let sortColumn = this.columns.filter((record) => record.dataIndex == sortBy)
          this.handleTableChange(null, null, { column: sortColumn, columnKey: sortBy, field: sortBy, order: orderBy })
        } else {
          this.loadData()
        }
      },
    },
    tableLoading(val) {
      this.loading = val
    },
  },
  data() {
    return {
      data: [],
      loading: false,
      config: {
        searchPlaceholder: '',
        loadData: () => {},
        pagination: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
        selectedAble: false,
        expandedAble: false,
      },
      selectedRowKeys: [],
      queryParam: {
        search: {},
        filter: {},
      },
      searchValue: '',
    }
  },
  methods: {
    loadData() {
      this.selectedRowKeys = []
      const pagination = this.config.pagination
      const pager = {
        pageNo: pagination.pageNo,
        pageSize: pagination.pageSize,
      }
      const query = {
        filter: { ...this.queryParam?.filter },
        search: { ...this.queryParam?.search },
      }
      if (this.searchValue && this.config.searchParam && this.config.searchParam.split('.').length >= 2) {
        const searchParam = this.config.searchParam.split('.')
        query[searchParam[0]][searchParam[1]] = this.searchValue
      }
      this.loading = true
      const requestParameters = Object.assign({}, this.order, pager, query)
      this.config
        .loadData(requestParameters)
        .then((res) => {
          if (this.config.afterLoadDataFunc) {
            this.config.afterLoadDataFunc(res)
          }
          this.config.pagination.total = res.content.totalCount
          this.data = res.content.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange(pagination, filters, sorter) {
      const order = {}
      if (sorter.order) {
        order.sortBy = sorter.field
        order.orderBy = sorter.order === 'ascend' ? 'asc' : 'desc'
      }
      this.$emit('sorter', sorter.order || false, sorter.field)
      this.order = Object.assign({}, order)
      this.loadData()
    },
    handleChangePage() {
      this.loadData()
    },
    handleChangePageSize() {
      this.config.pagination.pageNo = 1
      this.loadData()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleReset() {
      this.$emit('reset')
      this.searchValue = ''
      this.queryParam.search = {}
      this.queryParam.filter = { ...this.config.loadParam }

      this.order = {}
      const sorteredOne = this.columns.find((column) => column.sortOrder)
      if (sorteredOne) {
        this.$emit('sorter', false, sorteredOne.dataIndex)
      }

      this.config.pagination.pageNo = 1
      this.config.pagination.pageSize = 10

      if (this.config.orderParam) {
        var param = this.config.orderParam.split('.')
        let sortBy = param[0]
        let orderBy = param[1]
        let sortColumn = this.columns.filter((record) => record.dataIndex == sortBy)
        this.handleTableChange(null, null, { column: sortColumn, columnKey: sortBy, field: sortBy, order: orderBy })
      } else {
        this.loadData()
      }
    },
    handleRestart() {
      this.config.pagination.pageNo = 1
      this.config.pagination.pageSize = 10
      this.loadData()
    },
    handleFilter(val, param) {
      const searchParam = param.split('.')
      if (searchParam.length >= 2) {
        if (val && val.length > 0) {
          this.queryParam[searchParam[0]][searchParam[1]] = val
          // eslint-disable-next-line no-prototype-builtins
        } else if (
          this.queryParam.hasOwnProperty(searchParam[0]) &&
          this.queryParam[searchParam[0]].hasOwnProperty(searchParam[1])
        ) {
          delete this.queryParam[searchParam[0]][searchParam[1]]
        }
      }
      this.handleRestart()
    },
    // table 触发展开时调用此函数
    handleExpand(...param) {
      this.$emit('expand', ...param)
    },
    // handleSearch(selectedKeys, confirm, dataIndex) {
    //   confirm()
    //   this.searchText = selectedKeys[0]
    //   this.searchedColumn = dataIndex
    // },
  },
}
</script>
<style lang="less" scoped>
.flex-col {
  display: flex;
  flex-direction: column;
}

/deep/.ant-table-body {
  overflow-x: auto;
  background-color: #fff;
}
/deep/.ant-table-bordered .ant-table-thead > tr > th,
/deep/.ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 0;
}
</style>
